import styles from './PaginationBlock.module.scss';
import React from 'react';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { useSearchParams } from 'react-router-dom';
import { Pagination } from '../../../Components/react/Pagination';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../constants/searchParamKeys';
export const PaginationBlock = () => {
    const { nbPages } = useAlgoliaDataContext();
    const [searchParams, setSearchParams] = useSearchParams();
    if (nbPages < 2) {
        return null;
    }
    const page = +(searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1);
    return (React.createElement("div", { className: styles.container },
        React.createElement(Pagination, { totalPages: nbPages, currentPage: page, setPageFunction: (page) => {
                if (page > 1) {
                    searchParams.set(SEARCH_PARAM_KEY_PAGE_NUMBER, String(page));
                }
                else {
                    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
                }
                searchParams.sort();
                setSearchParams(searchParams);
            } })));
};
